import { Component, OnInit, ViewContainerRef, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { MatIconRegistry, MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ValidationService } from '../../../common/validationservice';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { StatesModel, CountryModel } from '../../../common/viewModels/kyc/clients';
import { PageResultDto } from '../../../common/viewModels/kyc/CustomerKycViewModel';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-statelist',
  templateUrl: './statelist.component.html',
  styleUrls: ['./statelist.component.scss']
})
export class StatelistComponent implements OnInit {
  message: string;
  model: StatesModel = new StatesModel();
  id: number;
  searchFields: StatesModel = new StatesModel();
  stateSearchForm: FormGroup;
  total: number;
  value: string;
  pager: any = {};
  pagedItems: any[];
  pageResult: PageResultDto;
  isNoRecords: boolean = true;
  addStatesForm: FormGroup;

  dialogRef: MatDialogRef<AddStateDialog>;
  lastCloseResult: string;
  actionsAlignment: string;
  config: MatDialogConfig = {
    disableClose: true,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '500',
    height: '',
    position: {
      top: '100',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      Name: 'Telangana', StateId: 0, CountryId: 1
    }
  };
  numTemplateOpens = 0;

  @ViewChild(TemplateRef) template: TemplateRef<any>;


  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent, private _pageSrvc: PagerService,
    private _toastrService: ToastrService, public dialog: MatDialog, @Inject(DOCUMENT) doc: any) {
    dialog.afterOpen.subscribe(() => {
      if (!doc.body.classList.contains('no-scroll')) {
        doc.body.classList.add('no-scroll');
      }
    });
    dialog.afterAllClosed.subscribe(() => {
      doc.body.classList.remove('no-scroll');
    });
  }

  OPenStateDialog() {

    this.dialogRef = this.dialog.open(AddStateDialog, this.config);

    this.dialogRef.afterClosed().subscribe((result: any) => {

      this.lastCloseResult = result;
      this.dialogRef = null;
    });
    // this.dialogRef.close();
  }

  ngOnInit() {
    this.CreateForm();
    // this.BindStaticSearchData();
    // this.setPage(0);

    this.addStatesForm = this._formBuilder.group({
      ClientId: [0],
      CustomerId: [0],
      TitleId: [0],
      FirstName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      MiddleName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      LastName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])]
    });

  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pageSrvc.globalPageSize;
  }

  CreateForm() {
    this.model = new StatesModel();
    this.stateSearchForm = this._formBuilder.group({
      CountryName: [this.model.CountryName],
      Name: [this.model.Name],
      CountryId: [this.model.CountryId],
      StateId: [this.model.StateId],
    })
  }

  onSubmit() {

    let searchDto = this.stateSearchForm.value;
    if (searchDto.CountryName != null)
      this.searchFields.CountryName = searchDto.CountryName;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(0);
  }

  AddStates() {

    this._mApp.ShowLoader();
    let statesData = this.addStatesForm.value;
    this._http.post(this._appUrl.AddUpdateStates, statesData)
      .subscribe(
        m => {
          this._mApp.HideLoader();
          this._toastrService.success(m.json().Result.StatusMessage, '');
          this.addStatesForm.reset();
          this.BindStatesList(0);
        }, error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result.StatusMessage, '');
        }
      )
  }


  EditState(id: number) {
    this._mApp.ShowLoader();

    this._http.get(this._appUrl.EditStateById + id)
      .subscribe(
        m => {
          this._mApp.HideLoader();
          if (m.json().Result != null) {
            this.addStatesForm.setValue(m.json().Result);
          }
        }, error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result.StatusMessage, '');
        }
      )
  }

  OnReset() {
    this.stateSearchForm.reset();
    this.CreateForm();
    this.searchFields.CountryName = '';
    this.searchFields.Name = '';
    this.setPage(0);
  }

  BindStatesList(page: number) {

    this.searchFields.PageNo = page - 1;
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetStatesList, this.searchFields)
      .subscribe(
        res => {

          var data = res.json();
          this.pagedItems = data.Result;
          this.isNoRecords = !(data.Result.length > 0);
          this.pageResult = data.PageResult;
          this.pager = this._pageSrvc.getPager(this.pageResult.TotalRecords, page);
          this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  AddStatre() {

    this._router.navigate(['/stateslist']);
  }

  setPage(page: number) {

    if (page === 0) {
      this.BindStatesList(1);
    }
    else if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    else {
      this.BindStatesList(page);
    }
  }


  DeleteState(id: number) {

    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteStateById + id)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          this.setPage(0);
          this._toastrService.success(res.json().Result, '');

        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

}


@Component({
  selector: 'demo-jazz-dialog',
  providers: [MainAppComponent],
  template: `
    <p>Add State</p>
    <form [formGroup]="addStatesForm" (ngSubmit)="onSubmit()">
    <mat-form-field>
        <mat-select placeholder="Title" formControlName="CountryId" id="ddrTitle" >
          <mat-option [value]="0">--Select--</mat-option>
          <mat-option *ngFor="let item of lstCountries" [value]="item.CountryId">
            {{ item.Name }}
          </mat-option>
        </mat-select>
        </mat-form-field>
<br>
      <mat-form-field>
        <input matInput formControlName="Name" placeholder="State Name">
      </mat-form-field>


      <div style="clear: both;"></div>
      <!--<button type="submit" mat-raised-button color="primary" mat-direction="right" title="Search"-->
              <!--(click)="onSubmit()">-->
        <!--<i class="fa fa-search" aria-hidden="true"></i>-->
        <!--Search-->
      <!--</button>-->
      <button type="button" (click)="onSubmit();dialogRef.close(addStatesForm.value)" mat-raised-button  color="primary">Save</button>
      <!--<button (click)="togglePosition()" >Change dimensions</button>-->
      <button
      mat-raised-button

      mat-dialog-close>Close
      </button>
    </form>`
})
export class AddStateDialog implements OnInit {
  private _dimesionToggle = false;
  addStatesForm: FormGroup;
  lstCountries: CountryModel[];

  stateData: StatesModel = new StatesModel();

  constructor(public dialogRef: MatDialogRef<AddStateDialog>, private _formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _http: CustomHttp, private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService, private _mApp: MainAppComponent
    , private _toastrService: ToastrService) {

    this.stateData = data;
  }

  ngOnInit() {

    this.addStatesForm = this._formBuilder.group({

      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])],
      CountryId: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      StateId: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      // CountryName: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100)])]
    });
    this.addStatesForm.setValue(this.stateData);
    this.GetCountries();
  }

  ngOnDestroy() {

  }

  GetCountries() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCountries)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.lstCountries = data.json().Result;

        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  togglePosition(): void {

    this._dimesionToggle = !this._dimesionToggle;

    if (this._dimesionToggle) {
      this.dialogRef
        .updateSize('500px', '500px')
        .updatePosition({ top: '25px', left: '25px' });
    } else {
      this.dialogRef
        .updateSize()
        .updatePosition();
    }
  }
  onSubmit(){}
}
